import { tokens } from "../tokens";

export const en = {
	[tokens.common.back]: "Back",
	[tokens.common.requiredField]: "* indicated a required field",
	[tokens.common.next]: "Next",
	[tokens.common.close]: "Close",
	[tokens.common.loading]: "Loading...",
	[tokens.common.goHome]: "Go Home",
	[tokens.common.cancel]: "Cancel",
	//
	[tokens.home.yourTasks]: "Your Tasks",
	[tokens.home.stepTitle]: "Step Title", // Example title, replace with actual dynamic titles
	[tokens.home.stepDescription]: "Step Description", // Example description, replace with actual dynamic descriptions
	[tokens.home.pendingApproval]:
		"Your request has been sent to the carrier for approval. Please wait.",
	[tokens.home.requestRejected]: "Your request was not approved by the carrier.",
	[tokens.home.requestAccepted]:
		"Congratulations! Your request to become a Carrier subsidiary has been accepted.",
	[tokens.home.buttonText]: "Next Step",
	[tokens.home.activeTab]: "Active",
	[tokens.home.archiveTab]: "Archive",
	[tokens.home.openTab]: "Open",
	//
	[tokens.addTrip.title]: "Add Trip",
	[tokens.addTrip.addTrip]: "Add Trip",
	[tokens.addTrip.addNewTrip]: "Add New Trip",
	[tokens.addTrip.completeInfoPrompt]:
		"You need to complete some information to create your first trip!",
	[tokens.addTrip.completeInfoQuestion]: "Would you like to complete that information now?",
	[tokens.addTrip.cancel]: "Cancel",
	[tokens.addTrip.completeInfo]: "Complete Info",
	//
	[tokens.trip.leavingFrom]: "Leaving From",
	[tokens.trip.startedOn]: "Started on",
	[tokens.trip.goingTo]: "Going to",
	[tokens.trip.finalizedMessage]: "Your trip is finalized. Please wait for the start time.",
	[tokens.trip.loadManagement]: "Load Management",
	[tokens.trip.realTimeTracking]: "Real-time Tracking",
	[tokens.trip.startTrip]: "Finalize Trip",
	[tokens.trip.attentions]: "Attentions",
	[tokens.trip.hazardous]: "Hazardous",
	[tokens.trip.doNotStack]: "Do Not Stack",
	[tokens.trip.deleteTripTitleOne]: "Are you sure you want to ",
	[tokens.trip.deleteTripTitleTwo]: "delete this trip?",
	[tokens.trip.deleteTripButton]: "Delete Trip",
	[tokens.trip.deleteTripDescription]:
		"Deleting this trip will remove it completely and cannot be undone. Please confirm if you wish to proceed. ",

	//
	//
	[tokens.editTrip.title]: "Edit Trip",

	//

	[tokens.loadCard.pickup]: "Pickup",
	[tokens.loadCard.delivery]: "Delivery",
	[tokens.loadCard.dueDate]: "DueDate",
	[tokens.loadCard.price]: "Cost",
	[tokens.loadCard.equipment]: "Equipment",
	[tokens.loadCard.totalWeight]: "Total Weight",
	[tokens.loadCard.itemCount]: "Item Count",
	[tokens.loadCard.totalLinear]: "Total Linear",
	[tokens.loadCard.details]: "Details",
	[tokens.loadCard.edit]: "Edit",

	//
	[tokens.loadDetailCard.pickup]: "Pickup",
	[tokens.loadDetailCard.delivery]: "Delivery",
	[tokens.loadDetailCard.dueDate]: "DueDate",
	[tokens.loadDetailCard.cost]: "Cost",
	[tokens.loadDetailCard.equipment]: "Equipment",
	[tokens.loadDetailCard.loadItems]: "Load Items",
	[tokens.loadDetailCard.totalWeight]: "Total Weight",
	[tokens.loadDetailCard.loadItemsList]: "Load Item List",
	[tokens.loadDetailCard.hideItems]: "Hide Items",
	[tokens.loadDetailCard.showItems]: "Show Items",
	[tokens.loadDetailCard.pickupServices]: "PickUp Services",
	[tokens.loadDetailCard.dropoffServices]: "DropOff Services",
	[tokens.loadDetailCard.totalLinear]: "Total Linear",
	//
	[tokens.loadItemCard.sizeOf]: "Size of",
	[tokens.loadItemCard.weightOf]: "Weight of",
	[tokens.loadItemCard.commodity]: "Commodity",
	[tokens.loadItemCard.unCode]: "UN Code",
	[tokens.loadItemCard.linearLoad]: "Linear Load",
	[tokens.loadItemCard.length]: "Length",
	//
	[tokens.loadSelectCard.detail]: "Detail",

	[tokens.loadSelectCard.deselect]: "Remove from Trip",
	[tokens.loadSelectCard.select]: "Add to Trip",

	//
	[tokens.login.title]: "Login",
	[tokens.loginOtp.verificationCode]: "Verification Code",
	[tokens.loginOtp.weSentTheCode]: "We've Sent The Code",
	[tokens.loginOtp.to]: "to",
	[tokens.loginOtp.edit]: "Edit",
	[tokens.loginOtp.verify]: "Verify",
	[tokens.loginOtp.resendCode]: "Resend Code",
	//
	[tokens.loginPhone.logInNow]: "Log In Now",
	[tokens.loginPhone.phoneNumberPlaceholder]: "Phone Number",
	[tokens.loginPhone.pleaseLoginWithPhone]: "Sign in using your email or phone number ",
	[tokens.loginPhone.phoneNumber]: "Phone Number",
	[tokens.loginPhone.countryCode]: "Country Code",
	[tokens.loginPhone.login]: "Login",
	//
	[tokens.resendTimer.remainingTimeToResend]: "Remaining Time To Resend",
	//
	[tokens.validation.cellphoneLength]: "Cellphone number must be exactly 10 characters long.",
	[tokens.validation.cellphoneRequired]: "Cellphone Required!",
	[tokens.validation.countryRequired]: "Country Code Required!",
	[tokens.validation.nameRequired]: "Name Required!",

	[tokens.validation.firstNameRequired]: "First Name Required!",
	[tokens.validation.lastNameRequired]: "Last Name Required!",
	[tokens.validation.emailRequired]: "Email Required!",
	[tokens.validation.priceRequired]: "Price Required!",
	[tokens.validation.emailInvalid]: "Invalid Email Address!",
	[tokens.validation.cellphoneMaximum]: "Phone number must be at most 20 characters",
	[tokens.validation.radiusMaximum]: "Number must be less than or equal to 250",
	[tokens.validation.zipCodeRequired]: "Zip Code Required!",
	[tokens.validation.radiusRequired]: "Radius Required!",
	[tokens.validation.modelMakeRequired]: "Model Make Required!",
	[tokens.validation.trailerNumberRequired]: "Trailer Number Required!",
	[tokens.validation.countRequired]: "Count Required!",
	[tokens.validation.unCodeRequired]: "UN Code Required!",
	[tokens.validation.totalWeightRequired]: "Total Weight Required!",
	[tokens.validation.lengthRequired]: "Length Required!",
	[tokens.validation.heightRequired]: "Height Required!",
	[tokens.validation.widthRequired]: "Width Required!",
	[tokens.validation.locationRequired]: "Location Required!",
	//
	[tokens.loads.title]: "Loads",
	[tokens.loads.addedToTripTab]: "Added",
	[tokens.loads.archivedTab]: "Archived",
	[tokens.loads.waitingForTripTab]: "Waiting",
	[tokens.loads.refresh]: "Refresh",
	[tokens.loads.loads]: "Loads",
	[tokens.loads.noShipments]: "You haven't Added any shipments yet.",
	[tokens.loads.completeProfile]: "Complete Profile",
	[tokens.loads.completeProfileDescription]: "To access this section, please complete your profile.",
	[tokens.loads.addLoad]: "Add Load",
	[tokens.loads.emptyLoads]: "You haven't Added any shipments yet.",
	//
	[tokens.ignoreLoads.optimizedLoads]: "Optimized Loads",
	[tokens.ignoreLoads.reloadOptimization]: "Reload Optimization",
	[tokens.ignoreLoads.noLoadsFound]: "No Loads were found for your trip.",
	[tokens.ignoreLoads.reloadOptimizationText]: "Tap 'Reload Optimization' to try again.",
	//
	[tokens.selectedLoads.loadManagementDescription]:
		"These loads are temporarily added to your trip.They will be confirmed once you start the trip.",
	[tokens.selectedLoads.optimizedLoads]: "Optimized Loads",
	[tokens.selectedLoads.reloadOptimization]: "Reload Optimization",
	[tokens.selectedLoads.noLoadsFound]: "No Loads were found for your trip.",
	[tokens.selectedLoads.reloadOptimizationText]: "Tap 'Reload Optimization' to try again.",
	[tokens.tripLoads.optimizedLoads]: "All Loads",
	[tokens.tripLoads.reloadOptimization]: "Reload Optimization",
	[tokens.tripLoads.noLoadsFound]: "No Loads were found for your trip.",
	[tokens.tripLoads.reloadOptimizationText]: "Tap 'Reload Optimization' to try again.",
	//
	[tokens.addLoad.title]: "Add Load",
	[tokens.addLoad.addLoad]: "Add Load",
	[tokens.addLoad.loadDetail]: "Load Detail",
	//
	[tokens.loadDetail.title]: "Load Detail",
	[tokens.loadDetail.loadDetail]: "Load Detail",
	[tokens.loadDetail.deleteLoad]: "Delete Load",
	[tokens.loadDetail.deleteLoadTitleOne]: "Are you sure you want to ",
	[tokens.loadDetail.deleteLoadTitleTwo]: "delete this load?",
	[tokens.loadDetail.deleteLoadButton]: "Delete Load",
	[tokens.loadDetail.deleteLoadDescription]:
		"Deleting this load will remove it completely and cannot be undone. Please confirm if you wish to proceed. ",

	//
	[tokens.loadManagement.title]: "Load Management",
	[tokens.loadManagement.loads]: "All Loads",
	[tokens.loadManagement.selected]: "Selected",
	[tokens.loadManagement.ignored]: "Ignored",
	[tokens.loadManagement.optimized]: "Optimized",
	[tokens.loadManagement.addOrEdit]: "Add Or Edit Loads",
	[tokens.loadManagement.reachTargetMessage]:
		"To reach the desired target, you need to select loads",
	[tokens.loadManagement.viewRouteOverview]: "View Route Overview",
	[tokens.loadManagement.finalizeTrip]: "Finalize Trip",
	[tokens.loadManagement.target]: "Target",
	[tokens.loadManagement.targetNotReached]: "Not Reached",
	[tokens.loadManagement.congratulations]: "Congratulations",
	[tokens.loadManagement.targetReached]: "Target Reached!",
	[tokens.loadManagement.notMetFinancialTarget]:
		"You have added loads, but haven't met your financial target. You can add more later.",
	[tokens.loadManagement.metFinancialTarget]:
		"You have met your financial target with the added loads. Great job!",
	[tokens.loadManagement.ok]: "Ok",
	[tokens.loadManagement.cancel]: "Cancel",
	[tokens.loadManagement.optimizeModalQuestion]:
		"If you accept optimization, the selected loads will be changed. Do you want to continue?",
	[tokens.loadManagement.exitLoadManagement]: "Exit Load Management",
	[tokens.loadManagement.startTripModalTitle]: "Ready to Finalize Your Trip?",
	[tokens.loadManagement.startTripModalDescriptionOne]: "Once you start your trip, ",
	[tokens.loadManagement.startTripModalDescriptionTwo]: "you won't be able to add or remove loads",
	[tokens.loadManagement.startTripModalDescriptionThree]: "Are you sure you want to proceed?",
	[tokens.loadManagement.startTripModalSubmit]: "Yes, Finalize Trip",
	[tokens.loadManagement.startTripModalCancel]: "Cancel",
	//
	[tokens.driverEdit.title]: "Driver Edit",
	//
	[tokens.userTypes.driver]: "Driver",
	[tokens.userTypes.operator]: "Dispatcher",
	[tokens.userTypes.carrier]: "Carrier",
	[tokens.userTypes.selfCarrier]: "Self Carrier",
	[tokens.userTypes.manager]: "Manager",
	[tokens.userTypes.shipper]: "Shipper",
	[tokens.userTypes.broker]: "Broker",
	[tokens.userTypes.admin]: "Admin",
	[tokens.userTypes.noSelect]: "No Select",
	//
	[tokens.profile.title]: "Profile",
	[tokens.profile.drivers]: "Drivers",
	[tokens.profile.carriers]: "Carriers",
	[tokens.profile.currentCarrier]: "Current",
	[tokens.profile.trucksTrailer]: "Trucks / Trailer",
	[tokens.profile.logOut]: "Log Out",
	[tokens.profile.completeProfile]: "Complete Profile",
	[tokens.profile.completeProfileDescription]:
		"To access this section, please complete your profile.",
	[tokens.profile.version]: "Version",
	[tokens.profile.upgradePlans]: "Upgrade to Premium",
	[tokens.profile.premiumPlans]: "Subscription Plan",
	[tokens.profile.trialPlanDescription]: "Unlock premium features for more control.",
	[tokens.profile.currentPlan]: "Your current plan",
	//
	[tokens.premiumPlans.title]: "Subscription Plan",
	[tokens.premiumPlans.trialDescription]:
		"Once your trial period ends, access to premium features will be disabled unless you upgrade.",
	[tokens.premiumPlans.trialLeft]: "trial left",
	[tokens.premiumPlans.upgradeNow]: "Upgrade now to keep enjoying all features",
	[tokens.premiumPlans.use]: "Use",
	[tokens.premiumPlans.allPlans]: "All Plans",

	[tokens.premiumPlans.weekly]: "Weekly",
	[tokens.premiumPlans.monthly]: "Monthly",
	[tokens.premiumPlans.yearly]: "Yearly",
	[tokens.premiumPlans.yourCurrentPlan]: "Your Current Plan",
	[tokens.premiumPlans.buyNow]: "Buy Now",
	//
	[tokens.datePicker.pickDate]: "Pick a Date",
	//
	[tokens.buyModal.congratulations]: "Congratulations!",
	[tokens.buyModal.ok]: "ok",
	[tokens.buyModal.congratulationsDescription]:
		"Your plan has been successfully purchased. Thank you for choosing us. For any assistance, please contact us.",

	//
	[tokens.expirePlanModal.description]:
		"Your current plan has expired. Please select a new plan to continue using all features without interruption",
	[tokens.expirePlanModal.viewPlans]: "View plans",
	[tokens.expirePlanModal.cancel]: "Cancel",
	[tokens.expirePlanModal.yourPlan]: "Your premium plan",
	[tokens.expirePlanModal.hasExpired]: "has expired",
	[tokens.premiumPlans.limitedTimeOffer]: "Limited Time Offer: Discount ends in",
	//
	[tokens.profileEdit.title]: "Profile (Edit)",
	[tokens.profileEdit.personal]: "Personal",
	[tokens.profileEdit.carrier]: "Carrier",
	//
	[tokens.truckEdit.title]: "Truck",
	//
	[tokens.tracking.title]: "Real-time Tracking",
	[tokens.tracking.error]: "Error",
	[tokens.tracking.pickupLocationInfo]: "Pickup Location",
	[tokens.tracking.dropOffLocationInfo]: "DropOff Location",
	[tokens.tracking.estimatedTime]: "Estimated Time",
	[tokens.tracking.cargoOwner]: "Cargo Owner",
	[tokens.tracking.doneCurrentStep]: "Done",
	[tokens.tracking.inProgress]: "In Progress",
	[tokens.tracking.tripSteps]: "Trip Steps",
	[tokens.tracking.estimatedArrival]: "Estimated Arrival",
	[tokens.tracking.startTripAt]: "Start trip at",
	[tokens.tracking.congratulations]: "Congratulations!",
	[tokens.tracking.tripEnded]: "Your trip has successfully ended.",
	[tokens.tracking.ok]: "Ok",
	[tokens.tracking.items]: "Current Load Items",

	//
	[tokens.userInformation.title]: "User Information",
	[tokens.userInformation.header]: "Let's Get Started!",
	[tokens.userInformation.profileTabTitle]: "Profile",
	[tokens.userInformation.carrierTabTitle]: "Carrier",
	[tokens.userInformation.driverTabTitle]: "Driver",
	[tokens.userInformation.truckTabTitle]: "Truck",
	[tokens.userInformation.readyTabTitle]: "Ready",
	//
	[tokens.dashboard.welcome]: "Hey, Welcome",
	[tokens.dashboard.loads]: "Loads",
	[tokens.dashboard.profile]: "Profile",
	[tokens.dashboard.loadBoard]: "LoadBoard",
	[tokens.dashboard.home]: "Home",
	[tokens.dashboard.account]: "Account",
	[tokens.dashboard.driver]: "driver",
	//
	[tokens.tripChart.target]: "Target",
	[tokens.tripChart.weight]: "Weight",
	[tokens.tripChart.volume]: "Volume",
	[tokens.tripChart.loads]: "Loads",
	[tokens.tripChart.totalLinear]: "Total Linear",
	[tokens.tripChart.items]: "items",
	//
	[tokens.tripFinalizeReview.startTripAt]: "Start trip at",
	//
	[tokens.tripRoute.routeStep]: "Route",
	[tokens.tripRoute.detailsStep]: "Details",
	[tokens.tripRoute.truckStep]: "Truck",
	[tokens.tripRoute.reviewStep]: "Review",
	//
	[tokens.tripRoute.tripName]: "Trip Name*",
	[tokens.tripRoute.addAnotherDestination]: "Add Another Destination",
	//
	[tokens.exitDialog.title]: "Are you sure you want ",
	[tokens.exitDialog.leave]: "to leave?",
	[tokens.exitDialog.tripLeavePrompt]:
		"If you go back now, all the information you've entered for this trip will be lost.",
	[tokens.exitDialog.loadLeavePrompt]:
		"If you go back now, all the information you've entered for this load will be lost.",
	[tokens.exitDialog.stayButton]: "Stay Here",
	[tokens.exitDialog.leaveButton]: "Leave",
	//
	[tokens.loadPrice.title]: "What is",
	[tokens.loadPrice.titleMiddle]: "the cost",
	[tokens.loadPrice.titleTwo]: "for transporting this load?",
	[tokens.loadPrice.subtitle]: "Please enter the cost you are willing to pay for moving this load.",
	[tokens.loadPrice.costLabel]: "Cost ($) *",
	[tokens.loadPrice.placeholder]: "Enter Cost",
	[tokens.loadPrice.loadPriceTitle]: "Transport cost",
	[tokens.loadPrice.ownerInfoTitle]: "Owner Info (optional)",
	[tokens.loadPrice.equipmentTitle]: "Equipment Type",
	[tokens.loadPrice.ownerNameLabel]: "Owner Name (Broker or Shipper)",
	[tokens.loadPrice.ownerPhoneNumberLabel]: "Owner PhoneNumber ",
	[tokens.loadPrice.ownerEmailLabel]: "Owner Email ",
	[tokens.loadPrice.enterZipCodePlaceholder]: "Enter ZipCode",
	[tokens.loadPrice.enterOwnerNamePlaceholder]: "Enter Owner Name",
	[tokens.loadPrice.enterEmailPlaceholder]: "Enter Owner Email",
	[tokens.loadPrice.enterOwnerPhoneNumberPlaceholder]: "Enter Owner PhoneNumber",
	[tokens.loadPrice.description]:
		"Please enter the price for how much you are willing to haul the load for.",
	//
	[tokens.loadReview.title]: "Is your shipment information correct?",
	[tokens.loadReview.subtitle]: "If everything is correct, finalize your shipment.",
	[tokens.loadReview.pickup]: "Pickup",
	[tokens.loadReview.pickupTime]: "Pickup Time",
	[tokens.loadReview.dropOff]: "DropOff",
	[tokens.loadReview.dropOffTime]: "DropOff Time",
	[tokens.loadReview.equipment]: "Equipment",
	[tokens.loadReview.cost]: "Cost",
	[tokens.loadReview.items]: "Items",
	[tokens.loadReview.totalWeight]: "Total Weight:",
	[tokens.loadReview.totalLinearFeet]: "Total linear feet:",
	[tokens.loadReview.shipmentDensity]: "Shipment density:",
	[tokens.loadReview.submit]: "Submit",
	[tokens.loadReview.edit]: "Edit",
	[tokens.loadReview.itemDimensionsError]:
		"Some load items are missing required dimensions. Linear items need weight and length; non-linear items need weight, length, width, and height.",

	[tokens.homeSteps.step1Title]: "Complete Profile",
	[tokens.homeSteps.step1Description]: "To get started, we need your basic information to proceed.",
	[tokens.homeSteps.step1ButtonText]: "Let's Get Started",
	[tokens.homeSteps.step2Title]: "Select Carrier",
	[tokens.homeSteps.step2Description]:
		"Please select your affiliated carrier to proceed. You'll be able to continue after it's confirmed by the carrier.",
	[tokens.homeSteps.step2ButtonText]: "Let’s select",
	[tokens.homeSteps.step3Title]: "Driver Management",
	[tokens.homeSteps.step3Description]:
		"Here, you can view drivers associated with your Carrier and add a new driver if needed, as you must have at least one driver to create a trip.",
	[tokens.homeSteps.step3ButtonText]: "Let’s Do",
	[tokens.homeSteps.step4Title]: "Review or Add Trucks",
	[tokens.homeSteps.step4Description]:
		"View trucks linked to your carrier or add a new one if permitted. At least one truck is needed to create a trip.",
	[tokens.homeSteps.step4ButtonText]: "Let’s Do",
	[tokens.homeSteps.step5Title]: "Create Your First Trip",
	[tokens.homeSteps.step5Description]: "You’re Ready to Create Your First Trip!",
	[tokens.homeSteps.step5ButtonText]: "Let’s Do",
	[tokens.tripList.activeTrips]: "Active Trips",
	[tokens.tripList.errorTitle]: "Error",
	[tokens.tripList.errorDescription]: "An error occurred while fetching trips.",
	[tokens.tripList.emptyDescription]: "Your carrier currently has no trips.",
	[tokens.userInfoProfile.completeInfo]: "Please Complete your information.",
	[tokens.userInfoProfile.editLater]: "You can edit this information later if needed.",
	[tokens.userInfoProfile.requiredField]: "* indicated a required field",
	[tokens.userInfoProfile.nameLabel]: "Name *",
	[tokens.userInfoProfile.lastNameLabel]: "Last Name *",
	[tokens.userInfoProfile.emailLabel]: "Email *",
	[tokens.userInfoProfile.editProfile]: "Edit Profile",
	[tokens.userInfoProfile.saveNextStep]: "Save And Next Step",

	[tokens.carrierForm.selfCarrier]: "I don't have any carrier",
	[tokens.carrierForm.carrierQuestion]: "Which carrier are you affiliated with?",
	[tokens.carrierForm.requestSent]: "Request Sent for Carrier Approval",
	[tokens.carrierForm.selectCarrier]: "select your carrier and request approval",
	[tokens.carrierForm.waitingApproval]: "Please wait patiently as we process your request.",
	[tokens.carrierForm.requestRejected]:
		"Your request was not approved by the carrier. Please select the correct carrier to proceed.",
	[tokens.carrierForm.selectCarrierLabel]: "Carrier*",
	[tokens.carrierForm.selectRoleLabel]: "Role*",
	[tokens.carrierForm.searchPlaceholder]: "Search by MC/USDOT Number Or Name",
	[tokens.carrierForm.role]: "Role",
	[tokens.carrierForm.submitRequest]: "Submit Request",
	[tokens.carrierForm.cancelRequest]: "Cancel Request",

	[tokens.carrierForm.carrierQuestion]: "Which carrier are you affiliated with?",
	[tokens.carrierForm.requestSent]: "Request Sent for Carrier Approval",
	[tokens.carrierForm.selectCarrier]: "select your carrier and request approval",
	[tokens.carrierForm.waitingApproval]: "Please wait patiently as we process your request.",
	[tokens.carrierForm.requestRejected]:
		"Your request was not approved by the carrier. Please select the correct carrier to proceed.",
	[tokens.carrierForm.selectCarrierLabel]: "Carrier*",
	[tokens.carrierForm.selectRoleLabel]: "Role*",
	[tokens.carrierForm.searchPlaceholder]: "Search by MC/USDOT Number Or Name",
	[tokens.carrierForm.role]: "Role",
	[tokens.carrierForm.submitRequest]: "Submit Approval Request",
	[tokens.carrierForm.cancelRequest]: "Cancel Approval Request",

	[tokens.driverInfo.addDriverTitle]: "What are the truck driver's details?",
	[tokens.driverInfo.approvedMessage]: "The carrier has approved your request, and you may proceed.",
	[tokens.driverInfo.driverDetails]:
		"Since you have been approved as a driver by the carrier, please complete your license information.",
	[tokens.driverInfo.completeLicenseInfo]:
		"Based on the permissions granted by your carrier, you can view and add drivers to the carrier.",
	[tokens.driverInfo.driversName]: "Driver's Name",
	[tokens.driverInfo.driversPhoneNumber]: "Driver’s Phone Number",
	[tokens.driverInfo.carrierDrivers]: "Carrier's Drivers",
	[tokens.driverInfo.more]: "... More",
	[tokens.driverInfo.addNewDriver]: "Add New Driver",
	[tokens.driverInfo.continue]: "Continue",

	[tokens.routeInfo.routeInfoTitleOne]: "Where will the load be",
	[tokens.routeInfo.routeInfoTitleTwo]: "picked up and DropOff?",
	[tokens.routeInfo.routeInfoDescription]: "Please enter the city and ZIP code for both locations.",
	[tokens.routeInfo.requiredFieldNote]: "* indicates a required field",
	[tokens.routeInfo.pickup]: "Pick Up",
	[tokens.routeInfo.dropOff]: "Drop Off",
	[tokens.routeInfo.zipCodeLabel]: "ZipCode *",

	[tokens.routeInfo.nextButtonTitle]: "Next",

	[tokens.dropOffDetails.shipmentDetailsTitle]: "What are the shipment DropOff details?",
	[tokens.dropOffDetails.requiredFieldNote]: "* indicates a required field",
	[tokens.dropOffDetails.zipCodeLabel]: "ZipCode *",
	[tokens.dropOffDetails.enterZipCodePlaceholder]: "Enter ZipCode",
	[tokens.dropOffDetails.nextButtonTitle]: "Next",

	[tokens.driverInfo.addDriverTitle]: "What are the truck driver's details?",
	[tokens.driverInfo.viewAddDriverTitle]: "View Or Add Driver",
	[tokens.driverInfo.approvedMessage]: "The carrier has approved your request, and you may proceed.",
	[tokens.driverInfo.driverDetails]:
		"Since you have been approved as a driver by the carrier, please complete your license information.",
	[tokens.driverInfo.completeLicenseInfo]:
		"Based on the permissions granted by your carrier, you can view and add drivers to the carrier.",
	[tokens.driverInfo.driversName]: "Driver's Name",
	[tokens.driverInfo.driversPhoneNumber]: "Driver’s Phone Number",
	[tokens.driverInfo.carrierDrivers]: "Carrier's Drivers",
	[tokens.driverInfo.more]: "... More",
	[tokens.driverInfo.addNewDriver]: "Add New Driver",
	[tokens.driverInfo.continue]: "Continue",

	[tokens.dropOffDetails.shipmentDetailsTitle]: "What are the shipment DropOff details?",
	[tokens.dropOffDetails.requiredFieldNote]: "* indicates a required field",
	[tokens.dropOffDetails.zipCodeLabel]: "ZipCode *",
	[tokens.dropOffDetails.enterZipCodePlaceholder]: "Enter ZipCode",
	[tokens.dropOffDetails.nextButtonTitle]: "Next",

	[tokens.carrierTrucks.carrierTrucksTitle]: "Carrier's Trucks",
	[tokens.carrierTrucks.moreButtonTitle]: "... More",
	[tokens.carrierTrucks.addNewTruckButtonTitle]: "Add New Truck",
	[tokens.carrierTrucks.continueButtonTitle]: "Continue",
	[tokens.carrierTrucks.driverName]: "Driver Name",
	[tokens.carrierTrucks.trailerId]: "Trailer ID",

	[tokens.otherDriverForm.phoneNumberLabel]: "Phone Number",
	[tokens.otherDriverForm.countryCodePlaceholder]: "Country Code",
	[tokens.otherDriverForm.phoneNumberPlaceholder]: "phone number",
	[tokens.otherDriverForm.firstNameLabel]: "First Name *",
	[tokens.otherDriverForm.firstNamePlaceholder]: "First Name",
	[tokens.otherDriverForm.lastNameLabel]: "Last Name *",
	[tokens.otherDriverForm.lastNamePlaceholder]: "Last Name",
	[tokens.otherDriverForm.noteText]:
		"Note: After this process, you can add any number of drivers to your profile.",
	[tokens.otherDriverForm.editDriverButtonTitle]: "Edit Driver Info",
	[tokens.otherDriverForm.saveAndNextButtonTitle]: "Save And Next Step",

	[tokens.selfDriverForm.licenseNumberLabel]: "Driver's License Number *",
	[tokens.selfDriverForm.licenseNumberPlaceholder]: "Driver's License Number",
	[tokens.selfDriverForm.editDriverButtonTitle]: "Edit Driver Info",
	[tokens.selfDriverForm.saveAndNextButtonTitle]: "Save And Next Step",

	[tokens.trailerInfo.trailerLabel]: "Trailer",
	[tokens.trailerInfo.trailerTypeLabel]: "Trailer Type*",
	[tokens.trailerInfo.trailerSizeLabel]: "Trailer Size*",
	[tokens.trailerInfo.trailerNumberLabel]: "Trailer Number *",
	[tokens.trailerInfo.enterTrailerNumberPlaceholder]: "Enter Trailer Number",
	[tokens.trailerInfo.maxCapacityLabel]: "Maximum Capacity",
	[tokens.trailerInfo.widthLabel]: "Width",
	[tokens.trailerInfo.lengthLabel]: "Length",
	[tokens.trailerInfo.heightLabel]: "Height",
	[tokens.trailerInfo.editButtonTitle]: "Edit",
	[tokens.trailerInfo.saveAndNextButtonTitle]: "Save And Next Step",

	[tokens.truckInfo.truckLabel]: "Truck",
	[tokens.truckInfo.truckOrTrailerType]: "Select Truck/Trailer Type",
	[tokens.truckInfo.truckIsStraight]: "The truck is a box truck (without a trailer).",
	[tokens.truckInfo.truckModelMakeLabel]: "Truck Model-Make*",
	[tokens.truckInfo.enterTruckModelMakePlaceholder]: "Enter Truck Model-Make",
	[tokens.truckInfo.continueButtonTitle]: "Continue",

	[tokens.truckWithoutTrailerInfo.truckLabel]: "Truck",
	[tokens.truckWithoutTrailerInfo.truckIsStraight]: "The truck is a box truck (without a trailer).",
	[tokens.truckWithoutTrailerInfo.truckTypeLabel]: "Trailer Type*",
	[tokens.truckWithoutTrailerInfo.truckSizeTypeLabel]: "Trailer Size*",
	[tokens.truckWithoutTrailerInfo.truckTypePlaceholder]: "Select Trailer Type",
	[tokens.truckWithoutTrailerInfo.truckSizeTypePlaceholder]: "Select Trailer Size",
	[tokens.truckWithoutTrailerInfo.truckModelMakeLabel]: "Truck Model-Make*",
	[tokens.truckWithoutTrailerInfo.truckModelMakePlaceholder]: "Enter Truck Model-Make",
	[tokens.truckWithoutTrailerInfo.capacityAndDimensionsLabel]: "Capacity & Dimensions",
	[tokens.truckWithoutTrailerInfo.maximumCapacityLabel]: "Maximum Capacity",
	[tokens.truckWithoutTrailerInfo.widthLabel]: "Width",
	[tokens.truckWithoutTrailerInfo.lengthLabel]: "Length",
	[tokens.truckWithoutTrailerInfo.heightLabel]: "Height",
	[tokens.truckWithoutTrailerInfo.saveAndNextButton]: "Save And Next Step",
	[tokens.truckWithoutTrailerInfo.editButton]: "Edit",

	[tokens.userInfoReady.congratulations]: "Congratulations!",
	[tokens.userInfoReady.readyToCreateTrip]: "You're now ready to create a trip",
	[tokens.userInfoReady.completedInfo]:
		"You've completed all the required information. Now that everything is set, you can create your first trip and embark on your journey.",
	[tokens.userInfoReady.driver]: "Driver",
	[tokens.userInfoReady.driverName]: "Driver Name",
	[tokens.userInfoReady.truck]: "Truck",
	[tokens.userInfoReady.truckModelMake]: "Trailer Model-Make",
	[tokens.userInfoReady.maxCapacity]: "Maximum Capacity",
	[tokens.userInfoReady.dimensions]: "Width * Length * Height",
	[tokens.userInfoReady.trailer]: "Trailer",
	[tokens.userInfoReady.trailerNumber]: "Trailer Number",
	[tokens.userInfoReady.trailerType]: "Trailer Type",
	[tokens.userInfoReady.skip]: "Go Home",
	[tokens.userInfoReady.letsCreateFirstTrip]: "Let's Create First Trip",
	[tokens.userInfoReady.continue]: "Continue",

	[tokens.userInfoTruck.titleTruckDetails]: "What are your Trailer's details?",
	[tokens.userInfoTruck.titleTrailerDetails]: "What are your Trailer's details?",
	[tokens.userInfoTruck.titleTruckOrTrailer]: "View Or Add Truck/Trailer",
	[tokens.userInfoTruck.enterVehicleInfo]: "Please enter your vehicle's information.",
	[tokens.userInfoTruck.viewAddTruck]:
		"Based on the permissions granted by your carrier, you can view or add Truck to the carrier.",
	[tokens.userInfoTruck.selectDriver]: "Select Truck’s Default Driver",
	[tokens.userInfoTruck.driver]: "Driver",
	[tokens.userInfoTruck.defaultDriver]: "Truck’s Default Driver*",
	[tokens.userInfoTruck.drivers]: "Drivers",
	[tokens.userInfoTruck.continue]: "Continue",

	[tokens.dropoffServices.additionalServices]: "Do you need any additional services at the",
	[tokens.dropoffServices.pickupLocation]: "Pickup location",
	[tokens.dropoffServices.selectServices]:
		"Please select any services needed for your shipment. If no additional services are needed, you may proceed.",

	[tokens.pickupServices.additionalServices]: "Do you need any additional services at the",
	[tokens.pickupServices.pickupLocation]: "Pickup location",
	[tokens.pickupServices.selectServices]:
		"Please select any services needed for your shipment. If no additional services are needed, you may proceed.",

	[tokens.loadEquipment.header]: "Which Option suits your shipment?",
	[tokens.loadEquipment.subHeader]:
		"Please select the option that best fits your shipment needs. This will help us ensure the appropriate transport method and equipment for your cargo.",
	[tokens.loadEquipment.equipmentLabel]: "Equipment *",
	[tokens.loadEquipment.equipmentType]: "Equipment Type",

	[tokens.loadItems.itemTypeLabel]: "Item Type*",
	[tokens.loadItems.commodityLabel]: "Commodity",
	[tokens.loadItems.countLabel]: "Count of this Item Type *",
	[tokens.loadItems.nonStackableLabel]: "The item is non-stackable.",
	[tokens.loadItems.widthLabel]: "Width",
	[tokens.loadItems.lengthLabel]: "Length",
	[tokens.loadItems.heightLabel]: "Height",
	[tokens.loadItems.linearLabel]: "Add By Linear feet",
	[tokens.loadItems.totalWeightLabel]: "Weight",
	[tokens.loadItems.hazardousLabel]: "This item contains hazardous material",
	[tokens.loadItems.unCodeLabel]: "UN Code",
	[tokens.loadItems.descriptionLabel]: "Item description",
	[tokens.loadItems.totalWeightRow]: "Total Weight:",
	[tokens.loadItems.totalLinearFeetRow]: "Total linear feet:",
	[tokens.loadItems.shipmentDensityRow]: "Shipment density:",

	[tokens.loadTime.loadTimeTextOne]: "Pickup availability",
	[tokens.loadTime.loadTimeTextTwo]: "and",
	[tokens.loadTime.loadTimeTextThree]: "delivery due date?",
	[tokens.loadTime.loadTimeTextInfo]:
		"You may optionally provide a pickup date and a delivery due date if desired.(these are optional)",
	[tokens.loadTime.pickupTitle]: "Pickup availability (optional)",
	[tokens.loadTime.dropOffTitle]: "Delivery due date (optional) ",
	[tokens.loadTime.readyForPickUp]: "Ready for PickUp",
	[tokens.loadTime.requestedInfo]:
		"Requested is subject to carrier acceptance and availability. (These are optional.)",
	[tokens.loadTime.requestedLoadingDate]: "Requested Loading Date",
	[tokens.loadTime.rangeFromTime]: "Range From Time",
	[tokens.loadTime.rangeToTime]: "Range To Time",
	[tokens.loadTime.dueDate]: "Due Date ",

	//
	[tokens.loadItems.whatItems]: "What",
	[tokens.loadItems.areYouShipping]: "Items",
	[tokens.loadItems.specifyItems]:
		"You can specify different items for your various packaging needs.",
	[tokens.loadItems.total]: "Total",
	[tokens.loadItems.editItem]: "Edit Item",
	[tokens.loadItems.removeItem]: "Remove Item",
	[tokens.loadItems.itemTypeLabel]: "Item Type*",
	[tokens.loadItems.itemTypePlaceholder]: "Item Type",
	[tokens.loadItems.commodityLabel]: "Commodity",
	[tokens.loadItems.commodityPlaceholder]: "Type or Select Commodity",
	[tokens.loadItems.countLabel]: "Count of this Item Type *",
	[tokens.loadItems.countPlaceholder]: "Count",
	[tokens.loadItems.nonStackableLabel]: "The item is non-stackable.",
	[tokens.loadItems.widthLabel]: "Width",
	[tokens.loadItems.widthPlaceholder]: "Width",
	[tokens.loadItems.lengthLabel]: "Length",
	[tokens.loadItems.lengthPlaceholder]: "Length",
	[tokens.loadItems.heightLabel]: "Height",
	[tokens.loadItems.heightPlaceholder]: "Height",
	[tokens.loadItems.totalWeightLabel]: "Total Weight",
	[tokens.loadItems.totalWeightPlaceholder]: "Total Weight",
	[tokens.loadItems.hazardousLabel]: "this item contain hazardous",
	[tokens.loadItems.unCodeLabel]: "UN Code",
	[tokens.loadItems.unCodePlaceholder]: "Enter UN Code",
	[tokens.loadItems.descriptionLabel]: "Item description",
	[tokens.loadItems.descriptionPlaceholder]: "Enter Item Description",
	[tokens.loadItems.totalWeightRow]: "Total Weight:",
	[tokens.loadItems.totalLinearFeetRow]: "Total linear feet:",
	[tokens.loadItems.shipmentDensityRow]: "Shipment density:",
	[tokens.loadItems.addAnotherItem]: "Add Another Item",

	[tokens.city.label]: "City",
	[tokens.city.placeholder]: "Select Your City",
	[tokens.city.selectHeader]: "Select Origin City",
	[tokens.city.searchPlaceholder]: "Search Origin City",

	[tokens.state.label]: "State",
	[tokens.state.placeholder]: "Select Your State",
	[tokens.state.selectHeader]: "Select Origin State",
	[tokens.state.searchPlaceholder]: "Search Origin State",

	[tokens.zipCode.label]: "ZipCode",
	[tokens.zipCode.placeholder]: "Select Your Zip Code",
	[tokens.zipCode.noZipCodeFound]: "No Zip Code Found",
	[tokens.zipCode.selectHeader]: "Select Your Zip Code",
	[tokens.zipCode.searchPlaceholder]: "search zipCode(type at least 3 character)",
	[tokens.zipCode.inputError]: "Invalid ZIP code. Please enter a valid 5-digit.",

	[tokens.tripTime.when]: "When",
	[tokens.tripTime.deportQuestion]: "do you deport?",
	[tokens.tripTime.dateDescription]: "Please specify the date your journey is scheduled to begin.",
	[tokens.tripTime.deportDateLabel]: "Deport Date",
	[tokens.tripTime.nextButtonTitle]: "Next",

	[tokens.tripTarget.questionPart1]: "When is Your",
	[tokens.tripTarget.questionPart2]: "Trip Scheduled",
	[tokens.tripTarget.questionPart3]: "and What is Your",
	[tokens.tripTarget.questionPart4]: "Revenue Target?",
	[tokens.tripTarget.description]:
		"Please enter the start date of your trip . Based on this target, suitable loads will be suggested to you.",
	[tokens.tripTarget.dateLabel]: "Date",
	[tokens.tripTarget.datePickerLabel]: "Depart Date *",
	[tokens.tripTarget.targetLabel]: "Your Target",
	[tokens.tripTarget.placeholder]: "Enter Revenue Target",
	[tokens.tripTarget.targetInputLabel]: "Revenue Target *",
	[tokens.tripTarget.radiusInputLabel]: "Radius *",
	[tokens.tripTarget.radiusLabel]: "Trip Radius Distance",
	[tokens.tripTarget.nextButtonTitle]: "Next",

	[tokens.tripReview.leavingFromTitle]: "Leaving From",
	[tokens.tripReview.goingToTitle]: "Going to",
	[tokens.tripReview.startDateTitle]: "Start Date",
	[tokens.tripReview.revenueTargetTitle]: "Revenue Target",
	[tokens.tripReview.nextButtonTitle]: "Create Trip",
	[tokens.tripReview.successTitle]: "Your trip has been",
	[tokens.tripReview.successTitleTwo]: " successfully created",
	[tokens.tripReview.successDescription]:
		"You can assign your desired loads to this trip at any time.",
	[tokens.tripReview.skipButton]: "Ok",
	[tokens.tripReview.addLoadsButton]: "Add Loads To Trip",

	[tokens.tripDetail.trucksAndDriverQuestion]: "Which of your Trucks And Driver is this trip for?",
	[tokens.tripDetail.trucksAndDriverDescription]:
		"Based on your selected vehicle and its capacity, optimized loads will be suggested and priced for you.",
	[tokens.tripDetail.truckLabel]: "Truck*",
	[tokens.tripDetail.selectTruckPlaceholder]: "Select Your Truck",
	[tokens.tripDetail.selectTruckTitle]: "Select your Truck",
	[tokens.tripDetail.errorTitle]: "Error",
	[tokens.tripDetail.driverLabel]: "Driver*",
	[tokens.tripDetail.selectDriverPlaceholder]: "Select Your Driver",
	[tokens.tripDetail.trailerLabel]: "Trailer*",
	[tokens.tripDetail.selectTrailerPlaceholder]: "Select Your Trailer",
	[tokens.tripDetail.nextButtonTitle]: "Next",

	[tokens.tripRoute.whatCityTextPart1]: "What’s Your",
	[tokens.tripRoute.whatCityTextPart2]: "Trip Route?",
	[tokens.tripRoute.selectCityDescription]:
		"Enter your starting point and destination. You can add multiple stops along the way if needed.",
	[tokens.tripRoute.originConfirmationButton]: "Origin Confirmation",
	[tokens.tripRoute.continueButton]: "Continue",
	[tokens.tripRoute.originTitle]: "Origin",
	[tokens.tripRoute.destinationTitle]: "Destination",

	[tokens.loadSteps.routeInfo]: "Route",
	[tokens.loadSteps.details]: "Details",
	[tokens.loadSteps.items]: "Items",
	[tokens.loadSteps.ready]: "Ready",
	[tokens.loadPickupServiceDescriptions.liftGate]:
		"When the location doesn't have a loading dock and your shipment is too heavy to lift without assistance",
	[tokens.loadPickupServiceDescriptions.insideLocation]:
		"When the driver needs to move the shipment from somewhere other than directly behind the truck",
	[tokens.loadPickupServiceDescriptions.limitedAccess]:
		"A non-residential location that may be difficult for a truck to access. i.e. farms, construction site, church, strip mall, school, etc.",
	[tokens.loadPickupServiceDescriptions.appointmentFree]:
		"When the carrier is required to contact final delivery location for specific appointment window",
	[tokens.loadItemTypeDescriptions.pallet]: "Pallet",
	[tokens.loadItemTypeDescriptions.skid]: "Skid",
	[tokens.loadItemTypeDescriptions.crate]: "Crate",
	[tokens.loadItemTypeDescriptions.bag]: "Bag",
	[tokens.loadItemTypeDescriptions.bale]: "Bale",
	[tokens.loadItemTypeDescriptions.bucket]: "Bucket",
	[tokens.loadItemTypeDescriptions.bundle]: "Bundle",
	[tokens.loadItemTypeDescriptions.can]: "Can",
	[tokens.loadItemTypeDescriptions.carton]: "Carton",
	[tokens.loadItemTypeDescriptions.case]: "Case",
	[tokens.loadItemTypeDescriptions.coil]: "Coil",
	[tokens.loadItemTypeDescriptions.cylinder]: "Cylinder",
	[tokens.loadItemTypeDescriptions.drums]: "Drums",
	[tokens.loadItemTypeDescriptions.pail]: "Pail",
	[tokens.loadItemTypeDescriptions.pieces]: "Pieces",
	[tokens.loadItemTypeDescriptions.reel]: "Reel",
	[tokens.loadItemTypeDescriptions.roll]: "Roll",
	[tokens.loadItemTypeDescriptions.tube]: "Tube",
	[tokens.loadItemTypeDescriptions.tote]: "Tote",
	[tokens.payment.failedTitle]: "Payment Failed",
	[tokens.payment.successTitle]: "Plan Activated!",
	[tokens.payment.failedDescription]:
		"It looks like your payment didn't go through, or the transaction was canceled. Please try again or choose a different payment method.",
	[tokens.payment.successMessage]:
		"Thank you for subscribing to <b>{{planTitle}}</b>. Your payment has been successfully processed, and your plan is now active until <b>{{expiryDate}}</b>. Enjoy your premium features!",
};
